














import Vue from "vue";
import { Location } from "vue-router";

interface Data {
  activated: boolean;
}

interface Props {
  active: boolean;
  icons: {
    default: string;
    selected?: string;
  };
  text: string;
  to: Location;
}

export default Vue.extend<Data, {}, {}, Props>({
  name: "NavBarLink",
  props: {
    active: { type: Boolean, required: true },
    icons: { type: Object, required: true },
    text: { type: String, required: true },
    to: { type: Object as () => Location, required: true }
  },
  data() {
    return {
      activated: false
    };
  },
  computed: {
    currentIcon() {
      if (this.icons.selected && (this.active || this.activated)) {
        return this.icons.selected;
      }
      return this.icons.default;
    }
  }
});
